module.exports = __webpack_public_path__ + "static/media/execution.3250bdf7.svg";